// "Icon (emoji)" in the Add Category / Add Subcategory dialogs: the emoji box works as before (type
// or paste any emoji), and the ▾ in it opens a panel of emojis to pick from, in tabs, with a search.
// The dialogs are SweetAlert `html` strings, so this is markup plus listeners added in `didOpen`.

// [emoji, words it is found by]. Single emojis only (no skin tones or joined ones such as 👩‍🏫), so
// each fits the box's 4 characters, and none newer than Emoji 11 so they show on older devices too.
export const EMOJI_GROUPS = [
  {
    label: "Learning",
    emojis: [
      ["📚", "books"], ["📖", "open book read"], ["📘", "blue book"], ["📗", "green book"], ["📕", "red book"],
      ["📙", "orange book"], ["📓", "notebook"], ["📒", "ledger notebook"], ["📔", "decorated notebook"],
      ["📝", "memo write notes"], ["✏️", "pencil write"], ["✒️", "nib pen"], ["🖊️", "pen"], ["🖍️", "crayon draw"],
      ["📏", "ruler"], ["📐", "set square triangle geometry"], ["✂️", "scissors craft"], ["📎", "paperclip"],
      ["📌", "pushpin"], ["🎒", "school bag"], ["🏫", "school"], ["🎓", "graduation cap"], ["🧮", "abacus maths count"],
      ["🔢", "numbers maths 1234"], ["🔤", "abc letters alphabet"], ["🔡", "lowercase letters abcd"],
      ["🔠", "uppercase letters abcd"], ["➕", "plus add maths"], ["➖", "minus subtract maths"],
      ["✖️", "multiply times maths"], ["➗", "divide maths"], ["🧠", "brain think"], ["💡", "idea light bulb"],
      ["🔍", "magnifier search find"], ["🔬", "microscope science"], ["🔭", "telescope space science"],
      ["🧪", "test tube science experiment"], ["🧬", "dna biology science"], ["🧲", "magnet science"],
      ["⚗️", "alembic chemistry science"], ["🌍", "globe earth geography world"], ["🗺️", "world map geography"],
      ["📊", "bar chart"], ["📈", "chart up progress"], ["📋", "clipboard"], ["📅", "calendar"], ["⏰", "alarm clock time"],
      ["💻", "laptop computer"], ["🖥️", "desktop computer"], ["⌨️", "keyboard typing computer"],
      ["🖱️", "mouse computer"], ["📱", "mobile phone"], ["🗣️", "speaking head language talk"],
      ["💬", "speech bubble talk"], ["❓", "question mark"], ["🏆", "trophy award winner"], ["🥇", "gold medal first"],
      ["🎖️", "military medal award"],
    ],
  },
  {
    label: "Arts & Music",
    emojis: [
      ["🎨", "palette art paint"], ["🖌️", "paintbrush art paint"], ["🖼️", "framed picture art"],
      ["🧵", "thread sewing craft"], ["🧶", "yarn knitting craft"], ["🏺", "pottery clay amphora"],
      ["🎭", "drama theatre masks acting"], ["🎬", "clapper board film"], ["🎥", "movie camera video"],
      ["📽️", "film projector"], ["🎞️", "film frames"], ["📷", "camera photo"], ["🎤", "microphone sing song"],
      ["🎙️", "studio microphone podcast"], ["🎧", "headphones listen"], ["🎵", "musical note music song"],
      ["🎶", "musical notes music song"], ["🎼", "musical score music"], ["🎹", "piano keyboard music"],
      ["🎸", "guitar music"], ["🎻", "violin music"], ["🎺", "trumpet music"], ["🎷", "saxophone music"],
      ["🥁", "drum music"], ["📯", "postal horn music"], ["🔔", "bell"], ["📻", "radio"], ["💃", "dancer dance woman"],
      ["🕺", "dancer dance man"], ["🧩", "puzzle piece jigsaw"], ["🎲", "dice game"], ["🃏", "joker card game"],
      ["🎯", "target dart bullseye"], ["🧸", "teddy bear toy"], ["🎈", "balloon party"], ["🎉", "party popper celebrate"],
      ["🎁", "gift present"], ["🎀", "ribbon bow"], ["✨", "sparkles magic"],
    ],
  },
  {
    label: "Sports & Games",
    emojis: [
      ["⚽", "football soccer sport"], ["🏀", "basketball sport"], ["🏏", "cricket bat ball sport"],
      ["🏸", "badminton sport"], ["🏓", "table tennis ping pong sport"], ["🎾", "tennis sport"],
      ["🏐", "volleyball sport"], ["🏈", "american football rugby sport"], ["⚾", "baseball sport"],
      ["🥎", "softball sport"], ["🏑", "field hockey sport"], ["🥅", "goal net sport"], ["⛳", "golf flag sport"],
      ["🏹", "bow arrow archery sport"], ["🥋", "martial arts karate judo sport"], ["🥊", "boxing glove sport"],
      ["♟️", "chess pawn game"], ["🤸", "cartwheel gymnastics exercise"], ["🧘", "yoga meditation exercise"],
      ["🏊", "swimming sport"], ["🚴", "cycling bike sport"], ["🏃", "running race sport"],
      ["🧗", "climbing sport"], ["🏋️", "weight lifting gym exercise"], ["🤾", "handball sport"],
      ["🛹", "skateboard"], ["⛸️", "ice skating"], ["🎳", "bowling game"], ["🏅", "sports medal award"],
      ["🏕️", "camping tent outdoor"], ["🎮", "video game controller"], ["🕹️", "joystick game"],
      ["🤹", "juggling"], ["🎪", "circus tent"],
    ],
  },
  {
    label: "Nature",
    emojis: [
      ["🌳", "tree"], ["🌲", "evergreen tree"], ["🌴", "palm tree"], ["🌵", "cactus"], ["🌱", "seedling plant grow"],
      ["🌿", "herb leaf plant"], ["🍀", "four leaf clover luck"], ["🍁", "maple leaf autumn"],
      ["🍂", "fallen leaves autumn"], ["🌷", "tulip flower"], ["🌹", "rose flower"], ["🌻", "sunflower flower"],
      ["🌼", "blossom flower"], ["🌸", "cherry blossom flower"], ["🌺", "hibiscus flower"], ["💐", "bouquet flowers"],
      ["☀️", "sun sunny weather"], ["🌙", "crescent moon night"], ["⭐", "star"], ["🌟", "glowing star"],
      ["🌠", "shooting star"], ["🌌", "milky way space"], ["🌈", "rainbow"], ["☁️", "cloud weather"],
      ["🌧️", "rain cloud weather"], ["⛈️", "storm thunder weather"], ["⚡", "lightning electricity"],
      ["❄️", "snowflake winter"], ["⛄", "snowman winter"], ["🔥", "fire flame"], ["💧", "water drop"],
      ["🌊", "wave sea ocean water"], ["🌋", "volcano"], ["⛰️", "mountain"], ["🏔️", "snow mountain"],
      ["🏝️", "island beach"], ["🌎", "globe americas earth"], ["🌏", "globe asia earth"],
    ],
  },
  {
    label: "Animals",
    emojis: [
      ["🐶", "dog puppy"], ["🐱", "cat kitten"], ["🐭", "mouse"], ["🐰", "rabbit bunny"], ["🦊", "fox"],
      ["🐻", "bear"], ["🐼", "panda"], ["🐨", "koala"], ["🐯", "tiger"], ["🦁", "lion"], ["🐮", "cow"], ["🐷", "pig"],
      ["🐸", "frog"], ["🐵", "monkey"], ["🐔", "chicken hen"], ["🐧", "penguin"], ["🐦", "bird"], ["🐤", "baby chick"],
      ["🦆", "duck"], ["🦉", "owl"], ["🦜", "parrot"], ["🦚", "peacock"], ["🐝", "honey bee"], ["🦋", "butterfly"],
      ["🐞", "ladybird ladybug"], ["🐌", "snail"], ["🐢", "turtle tortoise"], ["🐍", "snake"], ["🐠", "tropical fish"],
      ["🐬", "dolphin"], ["🐳", "whale"], ["🐙", "octopus"], ["🦀", "crab"], ["🐘", "elephant"], ["🦒", "giraffe"],
      ["🦓", "zebra"], ["🐪", "camel"], ["🐎", "horse"], ["🦄", "unicorn"], ["🦖", "dinosaur t-rex"],
      ["🐾", "paw prints"],
    ],
  },
  {
    label: "Food",
    emojis: [
      ["🍎", "apple fruit"], ["🍌", "banana fruit"], ["🍇", "grapes fruit"], ["🍉", "watermelon fruit"],
      ["🍊", "orange fruit"], ["🍓", "strawberry fruit"], ["🍍", "pineapple fruit"], ["🥭", "mango fruit"],
      ["🍒", "cherries fruit"], ["🍑", "peach fruit"], ["🥕", "carrot vegetable"], ["🌽", "corn vegetable"],
      ["🥦", "broccoli vegetable"], ["🍅", "tomato vegetable"], ["🥔", "potato vegetable"], ["🍞", "bread"],
      ["🍚", "cooked rice"], ["🍛", "curry rice"], ["🥘", "pan of food cooking"], ["🍲", "pot of food stew cooking"],
      ["🥗", "salad"], ["🍕", "pizza"], ["🍔", "burger"], ["🍪", "cookie biscuit"], ["🍰", "cake"],
      ["🎂", "birthday cake"], ["🧁", "cupcake"], ["🍦", "ice cream"], ["🍫", "chocolate"], ["🍬", "candy sweet"],
      ["🍩", "doughnut"], ["🥚", "egg"], ["🍯", "honey"], ["🥛", "glass of milk"], ["🍵", "tea"],
      ["☕", "coffee hot drink"],
    ],
  },
  {
    label: "People",
    emojis: [
      ["😊", "smile happy"], ["😀", "grin happy"], ["😄", "laugh happy"], ["😍", "heart eyes love"],
      ["🤩", "star struck"], ["😎", "cool sunglasses"], ["🤓", "nerd glasses study"], ["🤔", "thinking"],
      ["😮", "surprised wow"], ["😴", "sleeping sleepy"], ["🥳", "party face celebrate"], ["😇", "angel"],
      ["🤗", "hug"], ["👍", "thumbs up good"], ["👏", "clapping hands"], ["🙌", "raised hands celebrate"],
      ["👋", "waving hand hello"], ["✋", "raised hand"], ["🙋", "raising hand question"], ["🤝", "handshake"],
      ["🙏", "folded hands namaste pray thank you"], ["💪", "strong muscle"], ["✌️", "victory peace"],
      ["👀", "eyes look watch"], ["👂", "ear listen"], ["🧒", "child"], ["👦", "boy"], ["👧", "girl"], ["👶", "baby"],
      ["👨", "man"], ["👩", "woman"], ["🧑", "person"], ["👪", "family"], ["👫", "friends holding hands"],
    ],
  },
  {
    label: "Places & Things",
    emojis: [
      ["🏠", "house home"], ["🏡", "house garden home"], ["🏥", "hospital"], ["🏛️", "museum classical building"],
      ["🏰", "castle"], ["🏟️", "stadium"], ["🎡", "ferris wheel"], ["🎠", "carousel horse"], ["⛲", "fountain"],
      ["🌉", "bridge"], ["🏭", "factory"], ["🚌", "bus"], ["🚗", "car"], ["🚲", "bicycle"], ["🚂", "train"],
      ["✈️", "airplane travel"], ["🚀", "rocket space"], ["🛸", "flying saucer ufo"], ["⛵", "sailboat"],
      ["🚒", "fire engine"], ["🚑", "ambulance"], ["🚜", "tractor farm"], ["🧳", "luggage travel"],
      ["⚙️", "gear settings"], ["🔧", "wrench tool"], ["🔨", "hammer tool"], ["🛠️", "tools hammer wrench"],
      ["🧰", "toolbox"], ["🔌", "electric plug"], ["🔋", "battery"], ["💰", "money bag"], ["💵", "money note"],
      ["🛒", "shopping cart"], ["🧹", "broom clean"], ["🧼", "soap wash hygiene"], ["🧴", "lotion bottle"],
      ["🚿", "shower bath"], ["🛏️", "bed sleep"], ["💊", "medicine pill health"], ["☂️", "umbrella"],
      ["📦", "package box"], ["✉️", "envelope letter"], ["📮", "postbox letter"], ["🔑", "key"], ["🔒", "lock"],
    ],
  },
  {
    label: "Symbols",
    emojis: [
      ["❤️", "red heart love"], ["🧡", "orange heart"], ["💛", "yellow heart"], ["💚", "green heart"],
      ["💙", "blue heart"], ["💜", "purple heart"], ["💖", "sparkling heart"], ["✅", "check mark done"],
      ["✔️", "tick"], ["❌", "cross wrong"], ["⭕", "circle"], ["💯", "hundred points"], ["🔴", "red circle"],
      ["🔵", "blue circle"], ["🔶", "orange diamond"], ["🔷", "blue diamond"], ["🔺", "red triangle"],
      ["♻️", "recycle"], ["⚠️", "warning"], ["🚸", "children crossing"], ["♿", "wheelchair accessibility"],
      ["🆕", "new"], ["🆗", "ok button"], ["🔟", "number ten"], ["💤", "zzz sleep"], ["💥", "boom collision"],
      ["💫", "dizzy star"], ["🏁", "chequered flag finish"], ["🚩", "red flag"], ["📢", "loudspeaker announcement"],
      ["📣", "megaphone"], ["⏳", "hourglass time"], ["🔗", "link"], ["▶️", "play button"], ["➡️", "right arrow"],
      ["⬆️", "up arrow"], ["🔄", "repeat arrows"],
    ],
  },
];

const ALL_EMOJIS = EMOJI_GROUPS.flatMap((group) => group.emojis);

// "mus" finds 🎵 ("musical note music song"); each word typed must start one of the emoji's words.
const matches = ([emoji, words], query) =>
  emoji === query || query.split(/\s+/).every((part) => words.split(" ").some((word) => word.startsWith(part)));

// The field's markup for a dialog's `html`. `id` is the emoji box the dialog reads its value from.
export const emojiFieldHtml = (id) => `
  <div class="cm-emoji" id="${id}-picker">
    <label for="${id}">Icon (emoji)</label>
    <div class="cm-emoji__field">
      <input id="${id}" class="swal2-input" maxlength="4" value="📚" />
      <button type="button" class="cm-emoji__toggle" aria-label="Choose an emoji" aria-haspopup="true" aria-expanded="false" aria-controls="${id}-panel">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>
      </button>
    </div>
    <div id="${id}-panel" class="cm-emoji__panel" hidden>
      <input type="search" class="cm-emoji__search" placeholder="Search emoji, e.g. music" aria-label="Search emoji" autocomplete="off" />
      <div class="cm-emoji__tabs">
        ${EMOJI_GROUPS.map((group, i) => `<button type="button" class="cm-emoji__tab" data-group="${i}" title="${group.label}" aria-label="${group.label}" aria-pressed="false">${group.emojis[0][0]}</button>`).join("")}
      </div>
      <p class="cm-emoji__caption"></p>
      <div class="cm-emoji__grid" role="group" aria-label="Emojis"></div>
    </div>
  </div>`;

// Call from the dialog's `didOpen`.
export function wireEmojiField(id) {
  const input = document.getElementById(id);
  const root = document.getElementById(`${id}-picker`);
  if (!input || !root) return;
  const toggle = root.querySelector(".cm-emoji__toggle");
  const panel = root.querySelector(".cm-emoji__panel");
  const search = root.querySelector(".cm-emoji__search");
  const tabs = [...root.querySelectorAll(".cm-emoji__tab")];
  const caption = root.querySelector(".cm-emoji__caption");
  const grid = root.querySelector(".cm-emoji__grid");
  let group = 0;

  const show = () => {
    const query = search.value.trim().toLowerCase();
    const list = query
      ? ALL_EMOJIS.filter((entry) => matches(entry, query))
      : EMOJI_GROUPS[group].emojis;
    const current = input.value.trim();
    caption.textContent = query ? (list.length ? `Results for "${search.value.trim()}"` : "No emoji found") : EMOJI_GROUPS[group].label;
    grid.innerHTML = list
      .map(([emoji, words]) => {
        const picked = emoji === current;
        return `<button type="button" class="cm-emoji__item${picked ? " is-selected" : ""}" data-emoji="${emoji}" title="${words}" aria-pressed="${picked}">${emoji}</button>`;
      })
      .join("");
    tabs.forEach((tab, i) => {
      const active = !query && i === group;
      tab.classList.toggle("is-active", active);
      tab.setAttribute("aria-pressed", String(active));
    });
  };

  const setOpen = (open) => {
    panel.hidden = !open;
    toggle.setAttribute("aria-expanded", String(open));
    if (!open) return;
    // Opens on the tab holding the current emoji.
    const current = input.value.trim();
    const at = EMOJI_GROUPS.findIndex((g) => g.emojis.some(([emoji]) => emoji === current));
    group = at >= 0 ? at : 0;
    search.value = "";
    show();
    search.focus();
  };

  toggle.addEventListener("click", () => setOpen(panel.hidden));
  tabs.forEach((tab, i) =>
    tab.addEventListener("click", () => {
      group = i;
      search.value = "";
      show();
    })
  );
  search.addEventListener("input", show);
  grid.addEventListener("click", (event) => {
    const item = event.target.closest(".cm-emoji__item");
    if (!item) return;
    input.value = item.dataset.emoji;
    setOpen(false);
    toggle.focus();
  });
  // Escape closes just the panel, not the dialog (SweetAlert listens on the popup, above this).
  root.addEventListener("keydown", (event) => {
    if (event.key !== "Escape" || panel.hidden) return;
    event.preventDefault();
    event.stopPropagation();
    setOpen(false);
    toggle.focus();
  });
  // A click elsewhere in the dialog closes it too.
  (root.closest(".swal2-popup") || document).addEventListener("mousedown", (event) => {
    if (!panel.hidden && !root.contains(event.target)) setOpen(false);
  });
}
